import { render, staticRenderFns } from "./BranchAreaReportView.vue?vue&type=template&id=23bfbb87&scoped=true"
import script from "./BranchAreaReportView.vue?vue&type=script&lang=js"
export * from "./BranchAreaReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfbb87",
  null
  
)

export default component.exports